import { usePublicClient } from 'wagmi';

import { chainIds } from '@soundxyz/utils/constants/constants';
import { useStableCallback } from '@hooks/useStableCallback';
import { AVAILABLE_CHAIN_IDS } from '@utils/constants';

import { createContainer } from '../utils/unstated';

const Chain = createContainer(function useChainProvider() {
  const ethProvider = usePublicClient({ chainId: AVAILABLE_CHAIN_IDS.eth });
  const optimismProvider = usePublicClient({ chainId: AVAILABLE_CHAIN_IDS.optimism });
  const baseProvider = usePublicClient({ chainId: AVAILABLE_CHAIN_IDS.base });

  const provider = useStableCallback((chainId: number) => {
    switch (chainId) {
      case chainIds.GOERLI:
      case chainIds.MAINNET:
        return ethProvider;
      case chainIds.OPTIMISM_GOERLI:
      case chainIds.OPTIMISM:
        return optimismProvider;
      case chainIds.BASE:
      case chainIds.BASE_GOERLI:
        return baseProvider;
      default:
        throw new Error(`Invalid chainId ${chainId}`);
    }
  });

  return {
    provider,
  };
});

export const useChainProvider = () => Chain.useContainer();

export type ChainProviderContainerValue = ReturnType<typeof useChainProvider>;

export const ChainContext = Chain.Context;

export const ChainProvider = Chain.Provider;
